module.exports = __webpack_public_path__ + "img/pet_wishlist.17229527.png";